import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoadingSpinner from './components/LoadingSpinner';
import PWAInstallPrompt from './components/PWAInstallPrompt';

// Lazy load pages for better performance
const Login = lazy(() => import('./pages/Login'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const PWAInstall = lazy(() => import('./pages/PWAInstall'));
const SentryTest = lazy(() => import('./pages/SentryTest'));
const BarcodeTest = lazy(() => import('./pages/BarcodeTest'));

function App() {
  return (
    <Router>
      <PWAInstallPrompt />
      <Suspense fallback={<LoadingSpinner fullScreen message="Loading..." />}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/install-app" element={<PWAInstall />} />
          <Route path="/sentry-test" element={<SentryTest />} />
          <Route path="/barcode-test" element={<BarcodeTest />} />
          <Route path="/dashboard" element={<Navigate to="/dashboard/home" replace />} />
          <Route path="/dashboard/*" element={<Dashboard />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
